module.exports = "/images/next-bold.svg?dd1bff58d5921e9d35ddb8a6036cee9c";